import { useTheme } from "styled-components";

import { config } from "@sso/config";
import { Anchor } from "@sso/ui/Anchor";
import { ColumnContainer, RowContainer } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

interface BasemapLinkProps {
  title: string;
  href: string;
  color: string;
}

const BasemapLink = ({ title, href, color }: BasemapLinkProps) => (
  <Anchor
    margin="0.25rem 1rem"
    fontWeight="bold"
    color={color}
    textAlign="center"
    target="_blank"
    href={`${config.basemapURL}${href}`}
  >
    {title}
  </Anchor>
);

export const CommonPagesFooter = () => {
  const theme = useTheme();

  return (
    <ColumnContainer as="footer" height="20vh" minHeight="100px" justify="flex-start" padding="1rem 0 0 0">
      <RowContainer justify="space-evenly" width="100%" wrap="wrap">
        <BasemapLink title="About Us" href="/about-us" color={theme.colors.primary.dark} />
        <BasemapLink title="Contact Us" href="/contact-us" color={theme.colors.secondary.dark} />
        <BasemapLink title="General Terms & Conditions" href="/terms" color={theme.colors.primary.dark} />
        <BasemapLink title="Support & Services" href="/services" color={theme.colors.secondary.dark} />
      </RowContainer>
      <Typography margin="auto 0 0.75rem 0" display="initial">
        {"Copyright © "}
        <a href={config.basemapURL}>Basemap</a> {new Date().getFullYear()}
      </Typography>
    </ColumnContainer>
  );
};
